import { RadioTile } from '@bytel/trilogy-react';

import { formatPrice } from '@helpers/utils';

interface ItemBoxProps {
    active: boolean;
    title?: string;
    subTitle?: string;
    price: number;
    onChange: () => void;
    disabled?: boolean;
}

export function ItemBox({ active, subTitle, price, title, disabled, ...otherPros }: Readonly<ItemBoxProps>) {
    return (
        <RadioTile
            data-testid={`sim_choice_${title}`}
            checked={active}
            onChange={otherPros.onChange}
            disabled={disabled}
            horizontal
            label={`${title} ${formatPrice(price)}`}
            description={subTitle}
        />
    );
}
